import React, { Fragment } from 'react';
import {
    List, Datagrid, TextField,
    TextInput, SelectInput, SelectArrayInput, EditButton, DateInput,
    downloadCSV, Pagination, ReferenceManyField, SingleFieldList,
    NullableBooleanInput, BooleanInput, FunctionField, useRecordContext, usePermissions, useGetList
} from 'react-admin';
import { unparse as convertToCSV } from 'papaparse/papaparse.min';
import ValidateDevices from './Buttons/ValidateDevices';
import ApproveDevices from './Buttons/ApproveDevices';
import ValidateRegmanBulk from './Buttons/ValidateRegmanBulk';
import { useMediaQuery } from '@mui/material';
// import CreateRelatedDevice from './deviceRelatedDeviceButton';
import DeviceShow from './deviceShow';
import DeviceActions from './deviceActions';
import {
    Statuses, Statuses_Mag_Device,
    Anomalie_Filter, Statuses_Approvatore_Filter, Status_Regman,
    Statuses_DG_Filter, CheckNMU, Flag_olo, Check_u0009t, Progetto_con_Scarico, TipoNMU,
    TipoFamiglia, Causale_Addebito_Filter, Status_Collaudo_One, OneStep
} from '../objects';
import Attachment from '@mui/icons-material/Attachment';

const PostPagination = () => <Pagination rowsPerPageOptions={[10, 25]} />;

export const DeviceList = () => {
    const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));
    const { permissions } = usePermissions();
    const { isFetching } = useGetList('devices');

    /*  "Hack" to avoid a specific scenario:
            
            When filtering by a device and selecting it for BulckActions and then updating the device to a status that will no longer be visble on that list, after the update
            the user is redirected to the list, having 0 results but with the SN filter set and unable to unselect the row (BulckActions toolbar is above the filter box hiding it) ex:
                - Approvatore in Device view, updating a filtered by SN and selected device to Da Esaminare
    
            This "solution" will unselect the list items for every draw (runs several times causing exceptions in most of them) if there is a total = 0 (no results) and the selectedIDs is 1
    
            In version 3 of react-admin there is a button for the user to unselect all in the toolbar but in our case we don't have it.
        */
    // const { selectedIds, onUnselectItems } = useListContext();

    //TODO - Check if this is necessary with the new ReactAdmin
    // if (selectedIds) {
    //     let missingID = false;
    //     selectedIds.forEach(id => {
    //         if (!props.ids.includes(id)) missingID = true;
    //     })
    //     if (missingID) {
    //         try {
    //             onUnselectItems();
    //         }
    //         catch (error) {
    //             //A lot of exceptions are thrown but it still works
    //         }
    //     }
    // }

    const exporter = (devices) => {
        const devicesForExport = devices.map(device => {
            const { ...deviceForExport } = device;
            deviceForExport.status = device.status && device.status.descrizione;
            deviceForExport.causale = device.causale && device.causale.descrizione;
            deviceForExport.anomalia = device.anomalia && device.anomalia.descrizione;
            deviceForExport.status_regman = device.status_regman && device.status_regman.descrizione;
            deviceForExport['NMU WR'] = device.lista_NMU;
            deviceForExport['codice_impresa_utilizzo'] = device.codice_impresa_name;
            deviceForExport['descr_impresa_utilizzo'] = device.descrizione_impresa;
            deviceForExport['File Allegato'] = device.attachment_flag ? 'SI' : 'NO';
            deviceForExport.causale_addebito = device.causale_addebito && device.causale_addebito.descrizione;
            deviceForExport.status_collaudo_one = device.status_collaudo_one && device.status_collaudo_one.descrizione;
            deviceForExport.reverse = device.reverse && device.reverse.codice;
            if (device.note && device.note.includes('\n')) deviceForExport.note = device.note.replaceAll('\n', ' ');
            return deviceForExport;
        });

        const fields = ['serial_number_tim', 'serial_number_forn', 'createdBy', 'createdAt', 'updatedBy', 'updatedAt', 'num_consegna', 'workrequestid', 'externalrefid', 'associated_at', 'associated_by',
            'causale', 'anomalia', 'status', 'wr_prodotti', 'cod_terr_sap', 'cod_nmu', 'codice_impresa_name', 'impianto', 'impianto_regman', 'status_regman', 'sent_to_sap', 'cod_proj', 'mac_address',
            'serial_number_cpe', 'cod_terr_sap_mos', 'check_NMU', 'desc_nmu', 'tipo_task', 'flag_olo', 'check_u0009t', 'importo_u0009t', 'NMU WR', 'tipo_inserimento', 'client_type', 'data_completamento_wr', 'area', 'codice_riscontro',
            'codice_impresa_utilizzo', 'descr_impresa_utilizzo', 'tipo_famiglia', 'cod_gruppo_tec', 'File Allegato', 'contatore', 'causale_addebito', 'note_addebito', 'post_delivery', 'wr_collaudo_one', 'impianto_collaudo_one',
            'data_collaudo_one', 'status_collaudo_one', 'equivalenza_prod_applicabile', 'validated_at', 'validated_by', 'reverse', 'note', 'one_step', 'approved_at', 'approved_by']  // order fields in the export

        const csv = convertToCSV({
            data: devicesForExport,
            fields: fields
        });
        downloadCSV(csv, `Apparati${(new Date().getFullYear())}${("0" + (new Date().getMonth()+1)).slice(-2)}${("0" + new Date().getDate()).slice(-2)}${("0" + new Date().getHours()).slice(-2)}${("0" + new Date().getMinutes()).slice(-2)}${("0" + new Date().getSeconds()).slice(-2)}_${(new Date().getFullYear())}${("0" + (new Date().getMonth()+1)).slice(-2)}${("0" + new Date().getDate()).slice(-2)}${("0" + new Date().getHours()).slice(-2)}${("0" + new Date().getMinutes()).slice(-2)}${("0" + new Date().getSeconds()).slice(-2)}`);
    }


    const exporterDG = (devices) => {
        const devicesForExport = devices.map(device => {
            const { ...deviceForExport } = device;
            deviceForExport.status = device.status && device.status.descrizione;
            deviceForExport.causale = device.causale && device.causale.descrizione;
            deviceForExport.anomalia = device.anomalia && device.anomalia.descrizione;
            deviceForExport.status_regman = device.status_regman && device.status_regman.descrizione;
            deviceForExport['NMU WR'] = device.lista_NMU;
            deviceForExport['codice_impresa_utilizzo'] = device.codice_impresa_name;
            deviceForExport['descr_impresa_utilizzo'] = device.descrizione_impresa;
            deviceForExport['File Allegato'] = device.attachment_flag ? 'SI' : 'NO';
            deviceForExport.status_collaudo_one = device.status_collaudo_one && device.status_collaudo_one.descrizione;
            if (device.note && device.note.includes('\n')) deviceForExport.note = device.note.replaceAll('\n', ' ');
            return deviceForExport;
        });
        const fields = ['serial_number_tim', 'serial_number_forn', 'createdBy', 'createdAt', 'updatedBy', 'updatedAt', 'num_consegna', 'workrequestid', 'externalrefid', 'associated_at', 'associated_by',
            'causale', 'anomalia', 'status', 'wr_prodotti', 'cod_terr_sap', 'cod_nmu', 'codice_impresa_name', 'impianto', 'impianto_regman', 'status_regman', 'sent_to_sap', 'approved_at', 'cod_proj', 'mac_address',
            'serial_number_cpe', 'cod_terr_sap_mos', 'check_NMU', 'desc_nmu', 'tipo_task', 'flag_olo', 'check_u0009t', 'importo_u0009t', 'NMU WR', 'tipo_inserimento', 'client_type', 'data_completamento_wr', 'area', 'codice_riscontro',
            'codice_impresa_utilizzo', 'descr_impresa_utilizzo', 'tipo_famiglia', 'cod_gruppo_tec', 'File Allegato', 'contatore', 'post_delivery', 'wr_collaudo_one', 'impianto_collaudo_one',
            'data_collaudo_one', 'status_collaudo_one', 'equivalenza_prod_applicabile', 'note', 'one_step']  // order fields in the export

        const csv = convertToCSV({
            data: devicesForExport,
            fields: fields
        });
        downloadCSV(csv, `Apparati_${(new Date().getFullYear())}${("0" + (new Date().getMonth()+1)).slice(-2)}${("0" + new Date().getDate()).slice(-2)}${("0" + new Date().getHours()).slice(-2)}${("0" + new Date().getMinutes()).slice(-2)}${("0" + new Date().getSeconds()).slice(-2)}`);
    }

    const IsBackup = () => {
        //TO_SM_014
        let user_cod_terr_sap = localStorage.getItem('cod_terr_sap');
        if (user_cod_terr_sap && JSON.parse(user_cod_terr_sap)[0].startsWith("IB")) {
            return true
        }
        else {
            return false;
        }
    }

    const DeviceBulkActionButtons = () => {
        return <Fragment>
            {(permissions === 'magazziniere') ? <ValidateDevices /> : null}
            {(permissions === 'approvatore') ? <ApproveDevices /> : null}
            {(permissions === 'approvatore') ? <ValidateRegmanBulk /> : null}
        </Fragment>
    };

    const ShowEditButton = ({ ...rest }) => {
        const record = useRecordContext();
        if (!record) return null;

        var status = record.status ? record.status.codice : '';
        var editBtn = <EditButton record={record} {...rest} disabled={isFetching} />;

        if (permissions === 'tecnico') {
            return status === '1' ? editBtn : null;
        }
        else if (permissions === 'magazziniere') {
            return ((status === '0' || status === '1' || status === '2' || status === '6' || status === '12')) ? editBtn : null
        }
        else if (permissions === 'approvatore') {
            return (status === '3' || status === '4') ? editBtn : null;
        }
        else if (permissions === 'administrator') {
            return editBtn
        }
        else {
            return null
        }
    }

    const listValidation = (value, allValues) => {
        let error;
        if (value && typeof value === "string" && value.includes(',')) {
            let reg = /^[a-zA-Z0-9%,]*$/;
            if (!reg.test(value)) {
                error = "Puoi usare solo % , 0-9 A-Z";
            }
            else if (value.split(',').length > 100) {
                error = "Il filtro contiene più di 100 seriali";
            }
        }

        //Normally all this is not needed but in this case we use serial_number_tim with alwaysOn and in this case the error message is not shown by react-admin
        if (error) {
            if (!document.getElementById('serial_number_tim-helper-text')) {
                let input = document.getElementById('serial_number_tim').parentElement;
                let label = document.getElementById('serial_number_tim-label');
                let parent = input.parentElement;

                let newChild = document.createElement('p');
                newChild.className = 'MuiFormHelperText-root Mui-error MuiFormHelperText-sizeSmall MuiFormHelperText-filled css-u6loev-MuiFormHelperText-root';
                newChild.innerHTML = error;
                newChild.id = 'serial_number_tim-helper-text';
                newChild.style= 'display: block; font-size: 0.75rem; color: #d32f2f;';
                input.className = input.className + " Mui-error";
                label.className = label.className + " Mui-error";
                parent.appendChild(newChild);
            }
        }
        else if (document.getElementById('serial_number_tim-helper-text')){
            document.getElementById('serial_number_tim-helper-text').remove();
            document.getElementById('serial_number_tim').parentElement.className = document.getElementById('serial_number_tim').parentElement.className.replace(" Mui-error", "");
            document.getElementById('serial_number_tim-label').className = document.getElementById('serial_number_tim-label').className.replace(" Mui-error", "");
        }
        return error;
    };

    const validateList = [listValidation]
    const ShowAttachmentIcon = () => {
        const record = useRecordContext();
        if (!record) return null;
        return record.attachment_flag ? <Attachment /> : null
    }


    const formatSerialFilter = (v) => {
        if (v && v.$in && Array.isArray(v.$in)) {
            return v.$in.join();  // join array into a string
        }
        return v || '';  // ensure it returns a valid string (default empty string if v is falsy)
    }

    const deviceFilters = [
        <TextInput source="serial_number_tim" alwaysOn style={{ width: '275px' }} validate={validateList} format={formatSerialFilter} />,
        <TextInput source="workrequestid" />,
        <TextInput source="serial_number_forn" />,
        <TextInput source="mac_address" />,
        <TextInput source="associated_by" />,
        <DateInput source="associated_at_gte" />,
        <DateInput source="associated_at_lte" />,
        <TextInput source="cod_terr_sap" />,
        <TextInput source="cod_terr_sap_mos" />,
        <TextInput source="impianto" />,
        <TextInput source="cod_nmu" />,
        ...(permissions === 'approvatore' || permissions === 'dg') ? [<TextInput source="magmoi.codice_impresa_sap" label="Codice SAP Impresa" />] : [],
        ...(permissions === 'approvatore' || permissions === 'dg') ? [<SelectInput source="tipo_task" choices={[{ id: 'ASSURANCE', name: 'ASSURANCE' }, { id: 'DELIVERY', name: 'DELIVERY' }]} />] : [],
        ...(permissions === 'approvatore' || permissions === 'dg') ? [<SelectInput source="tipo_inserimento" choices={[{ id: 'Digitato', name: 'Digitato' }, { id: 'Scansionato', name: 'Scansionato' }, { id: 'DaLista', name: 'DaLista' }]} />] : [],
        ...(permissions === 'approvatore' || permissions === 'dg') ? [<TextInput source="approved_by" />] : [],
        ...(permissions === 'approvatore' || permissions === 'dg') ? [<DateInput source="validated_at_gte" />] : [],
        ...(permissions === 'approvatore' || permissions === 'dg') ? [<DateInput source="validated_at_lte" />] : [],
        ...(permissions === 'approvatore' || permissions === 'dg' || permissions === 'magazziniere') ? [<TextInput source="impianto_regman" />] : [],
        /* {permissions === 'approvatore' && <TextInput source="divisione" />} */
        ...permissions === 'approvatore' ? [<SelectArrayInput source="status.codice" choices={Statuses_Approvatore_Filter} />] : [],
        ...permissions === 'dg' ? [<SelectArrayInput source="status.codice" choices={Statuses_DG_Filter} />] : [],
        ...(permissions === 'administrator') ? [<SelectArrayInput source="status.codice" choices={Statuses} />] : [],
        ...(permissions === 'magazziniere') ? [<SelectArrayInput source="status.codice" choices={Statuses_Mag_Device} />] : [],
        <SelectArrayInput source="anomalia.codice" choices={Anomalie_Filter} />,
        <SelectInput source="status_regman.codice" choices={Status_Regman} />,
        <DateInput source="createdAt_gte" />,
        <DateInput source="createdAt_lte" />,
        <DateInput source="sent_to_sap_gte" />,
        <DateInput source="sent_to_sap_lte" />,
        <TextInput source="num_consegna" />,
        <SelectInput source="flag_olo" choices={Flag_olo} />,
        <SelectInput source="check_NMU" choices={CheckNMU} label="Check NMU" />,
        ...permissions === 'dg' ? [<SelectInput source="tipo_nmu" choices={TipoNMU} label="RP_NMU: Tipo NMU" style={{ 'min-width': '190px' }} />] : [],
        ...permissions === 'dg' ? [<SelectArrayInput source="progetto_con_scarico" choices={Progetto_con_Scarico} label="RP_NMU: Progetto con Consegna Prodotti" style={{ 'min-width': '190px' }} />] : [],
        ...(permissions === 'approvatore' || permissions === 'dg') ? [<SelectInput source="check_u0009t" choices={Check_u0009t} />] : [],
        <BooleanInput source="attachment_flag" />,
        <DateInput source="data_completamento_wr_gte" />,
        <DateInput source="data_completamento_wr_lte" />,
        <TextInput source="codice_impresa_name" label="Codice Impresa Utilizzo" />,
        <TextInput source="descrizione_impresa" label="Descrizione Impresa Utilizzo" />,
        <SelectInput source="tipo_famiglia" choices={TipoFamiglia} label="Tipo Famiglia" />,
        <TextInput source="cod_gruppo_tec" />,
        <SelectInput source="contatore" choices={[{ id: 'NULL', name: '0' }, { id: 1, name: '1' }, { id: 2, name: '2' }, { id: 3, name: '3' }, { id: 4, name: '4' }, { id: 5, name: '5' }, { id: 6, name: '6' }
            , { id: 7, name: '7' }, { id: 8, name: '8' }]} label="Contatore" />,
        <SelectArrayInput source="causale_addebito.codice" choices={Causale_Addebito_Filter} />,
        <TextInput source="wr_collaudo_one" />,
        <TextInput source="impianto_collaudo_one" />,
        <DateInput source="data_collaudo_one_gte" />,
        <DateInput source="data_collaudo_one_lte" />,
        <SelectInput source="status_collaudo_one.codice" choices={Status_Collaudo_One} label="Stato CollaudoOne" />,
        <SelectInput source="one_step" choices={OneStep} label="ONE STEP" />,
        <TextInput source="nomenclatore.divresp" label="Divisione Responsabile" />
    ];

    return (
        <List empty={false} filters={deviceFilters} actions={<DeviceActions />} exporter={permissions !== 'dg' ? exporter : exporterDG} pagination={<PostPagination />} >
            {isSmall ? (
                <Datagrid rowClick="expand" expand={<DeviceShow />}
                    bulkActionButtons={(permissions !== 'administrator' && permissions !== 'tecnico' && permissions !== 'dg' && !IsBackup()) ? <DeviceBulkActionButtons /> : false}
                >
                    <TextField source="serial_number_tim" />
                    <TextField source="workrequestid" />
                    <ShowEditButton />
                    {/* <EditButton /> */}
                    {/* <CreateRelatedDevice /> */}
                </Datagrid>
            ) : (
                <Datagrid rowClick="expand" expand={<DeviceShow />}
                    bulkActionButtons={<DeviceBulkActionButtons />}
                >
                    <TextField source="serial_number_tim" />
                    <TextField source="workrequestid" />
                    {(permissions !== 'approvatore' && permissions !== 'dg') && <TextField source="cod_terr_sap" />}
                    {(permissions === 'approvatore' || permissions === 'dg') && <TextField source="divisione" />}
                    {(permissions === 'approvatore' || permissions === 'dg') && <TextField source="codice_magazzino" />}
                    {(permissions === 'approvatore' || permissions === 'dg') && <ReferenceManyField
                        resource="devices"
                        reference="magmois"
                        target="cod_terr_sap"
                        source="cod_terr_sap"
                        basePath="/devices"
                        label="Codice SAP Impresa"
                        linkType={false}
                    >
                        <SingleFieldList linkType={false}>
                            <TextField source="codice_impresa_sap" />
                        </SingleFieldList>
                    </ReferenceManyField>}
                    {(permissions === 'approvatore' || permissions === 'dg') && <TextField source="impianto" />}
                    <TextField source="cod_nmu" />
                    <TextField source="status.descrizione" />
                    <TextField source="causale.descrizione" />
                    <TextField source="anomalia.descrizione" />
                    <FunctionField label="Contatore" render={record => { return record.contatore ? record.contatore : 0 }} />
                    <ShowEditButton />
                    <ShowAttachmentIcon />
                    {/* <EditButton /> */}
                    {/* <CreateRelatedDevice /> */}
                </Datagrid>
            )}
        </List>
    )
};

